





















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { db } from '@/main';
import * as firebase from 'firebase/app';
import User from '@/interfaces/User';
import Store from '@/interfaces/Store';

@Component
export default class Dashboard extends Vue {
  drawer: boolean;

  currentUser: User;

  userStore: Store;

  storeName: string;

  constructor() {
    super();
    this.drawer = true;
    this.currentUser = {} as User;
    this.userStore = {} as Store;
    this.storeName = 'SimpleWonder Inventory';
  }

  created() {
    this.currentUser = this.$store.state.currentUser;
    if (this.currentUser) {
      db.collection('stores').doc(this.currentUser.storeId).get().then((snapshot) => {
        this.userStore = snapshot.data() as Store;
      });
    }
  }

  get currentUserStore() {
    return this.$store.state.currentUser;
  }

  @Watch('currentUserStore')
  onCurrentUserStoreChanged(value: User) {
    this.storeName = value.name;
  }

  get getStoreName() {
    if (this.userStore && this.userStore.storeName) {
      return this.userStore.storeName;
    }
    return 'SimpleWonder Inventory';
  }

  signoutUser() {
    firebase.auth().signOut().then(() => {
      this.$router.push({ name: 'Home' });
    });
  }
}
